// extracted by mini-css-extract-plugin
export default {"modal-actions":"Welcome--modal-actions--WTZ7t","modalActions":"Welcome--modal-actions--WTZ7t"};